import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightCaret = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 6L0.500001 11.1962L0.500001 0.803848L8 6Z",
		fill: "#282828"
	})
});
export default SvgRightCaret;
